import axios from "axios";
import { IServiceResult, IStore, ITerritory, IUser } from "../../Models/Models";
import { IUserManagementAxios } from "../IUserManagementAxios";

export class UserManagementAxios implements IUserManagementAxios {
    public GetUserFranchiseeStoreInformation(
        userId: number
    ): Promise<IServiceResult<Array<IStore>>> {
        const promise = new Promise<IServiceResult<Array<IStore>>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<Array<IStore>>>(`/Users/GetUserAssignStoresData?userId=${userId}`)
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }

    public GetUserFranchiseeTerritoryInformation(
        userId: number
    ): Promise<IServiceResult<Array<ITerritory>>> {
        const promise = new Promise<IServiceResult<Array<ITerritory>>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<Array<ITerritory>>>(
                        `/Users/GetUserAssignTerritoryData?userId=${userId}`
                    )
                    .then(
                        (response) => {
                            resolve(response.data);
                        },
                        (error) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }

    public RemoveStoreFromFranchiseeUser(
        userID: number,
        storeID: number
    ): Promise<IServiceResult<boolean>> {
        const promise = new Promise<IServiceResult<boolean>>((resolve, reject) => {
            axios
                .post<IServiceResult<boolean>>("/Stores/RemoveStoreFromFranchiseUser", {
                    userID: userID,
                    storeID: storeID,
                })
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    public RemoveTerritoryFromFranchiseeUser(
        userID: number,
        territoryID: number
    ): Promise<IServiceResult<boolean>> {
        const promise = new Promise<IServiceResult<boolean>>((resolve, reject) => {
            axios
                .post<IServiceResult<boolean>>(
                    "/Territories/RemoveTerritoryFromFranchiseUser",
                    {
                        userID: userID,
                        territoryID: territoryID,
                    }
                )
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    public UpdateUserActiveStatus(
        userId: number,
        activeStatus: boolean
    ): Promise<IServiceResult<IUser>> {
        const promise = new Promise<IServiceResult<IUser>>((resolve, reject) => {
            axios
                .post<IServiceResult<IUser>>("/Users/Deactivate", {
                    userId,
                    activeStatus,
                })
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }

    public UpdateSessionTimeoutLength(
        companyId: number,
        newSessionTimeoutLength: number
    ): Promise<IServiceResult<IUser>> {
        const promise = new Promise<IServiceResult<IUser>>((resolve, reject) => {
            axios
                .post<IServiceResult<IUser>>("/Company/UpdateSessionTimeoutLengthMinutes", {
                    cid: companyId,
                    sessionTimeoutLengthMinutes: newSessionTimeoutLength,
                })
                .then(
                    (response) => {
                        resolve(response.data);
                    },
                    (error) => {
                        reject(error);
                    }
                );
        });

        return promise;
    }
}
